// eslint-disable-next-line no-use-before-define
import { Icon, mediaQueries, palette, Select } from '@centivo/react-components'
import styled from 'styled-components'

import { SearchBarForm } from 'src/refactor/components/SearchBarForm'
import { ContentSection } from 'src/refactor/structure'

import { useMediaContext } from 'src/context/responsive'
import { IconDoctor, IconHealth } from '../../../../../assets/icons'
import { CATEGORY } from '../../../../helpers/constants'
import { SearchBarButtonDefault } from './SearchBarButtonDefault'
import { useSearchBarFunctions } from './useSearchBarFunctions'

const StyledContentSection = styled(ContentSection)`
  @media ${mediaQueries.mobile} {
    padding-bottom: calc(6.25rem - 2rem) !important;
  }
`

const SearchBarContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .network-selector {
    margin-bottom: 2.5rem;
    max-width: 430px;
    width: 100%;

    @media ${mediaQueries.desktop} {
      width: 440px;
      max-width: unset;
    }
  }
`

const SearchBarTitle = styled.h2`
  color: ${palette.brand.darkGreen};
  font-size: 1.875rem;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 1rem;
  text-align: center;
`

const SearchBarButtonsGroup = styled.div`
  align-items: start;
  display: flex;
  justify-content: center;
  margin-bottom: 3.25rem;
`

const SearchBarMessage = styled.p`
  font-size: 0.75rem;
  font-style: italic;
  font-weight: 500;
  line-height: 1.325;
  color: #59616e;
  a {
    color: inherit;
    font-weight: bold;
  }
`

export const SearchBarDefault = () => {
  const {
    state,
    networkSelectionEnabled,
    template,
    category,
    shouldShowDisclaimer,
    disableTabButtons,
    planNetworkOptions,

    handleNetworkSelected,
    toggleCategory,
    onSubmit,
  } = useSearchBarFunctions()

  const { isMobileView } = useMediaContext()

  return (
    <StyledContentSection id="find-a-doctor">
      <SearchBarContentSection>
        {template !== 'template-3' && (
          <SearchBarTitle>Find a doctor or facility</SearchBarTitle>
        )}
        {networkSelectionEnabled && (
          <Select
            className="network-selector"
            placeholder="Select your network"
            options={planNetworkOptions}
            onSelect={handleNetworkSelected}
            isSearchable={false}
            value={state.selectedPlan}
            isClearable
            float
          />
        )}
      </SearchBarContentSection>
      {!disableTabButtons && (
        <SearchBarButtonsGroup>
          <SearchBarButtonDefault
            selected={category === CATEGORY.DOCTOR}
            onClick={() => toggleCategory(CATEGORY.DOCTOR)}
            title="Doctor"
            icon={
              <Icon
                aria-hidden
                icon="slice-doctor"
                size={isMobileView ? '3.798rem' : '5rem'}
              />
            }
          />
          <SearchBarButtonDefault
            selected={category === CATEGORY.FACILITY}
            onClick={() => toggleCategory(CATEGORY.FACILITY)}
            title="Facility"
            icon={
              <Icon
                aria-hidden
                icon="slice-health"
                size={isMobileView ? '3.798rem' : '5rem'}
              />
            }
          />
        </SearchBarButtonsGroup>
      )}
      {!disableTabButtons && category && (
        <SearchBarForm
          category={category ?? CATEGORY.DOCTOR}
          onSubmit={onSubmit}
        />
      )}
      {!disableTabButtons && category && (
        <aside>
          <SearchBarMessage>
            Provider information in the Centivo provider directory is updated
            regularly and can change at any time. Before scheduling
            appointments, please check the Centivo app or{' '}
            <a href="https://my.centivo.com/" target="_blank" rel="noreferrer">
              my.centivo.com
            </a>{' '}
            to make sure the provider is in-network, and then call their office
            directly. A provider’s appointment availability can’t be guaranteed.
            If something looks incorrect in the directory, please email us at
            ProviderRelations@centivo.com.
          </SearchBarMessage>
        </aside>
      )}
    </StyledContentSection>
  )
}
